import { convertEventBodyJson } from './convert-event-body-json'

/**
 * cellList 를 받아
 * event_list 의 on-zzim, off-zzim bodylist 를 bodyjson 으로 변환하여
 * cellList 를 반환
 * @param cellList
 * @returns cellList | []
 */
export const previewCell = (cellList = []) => {
  if (cellList?.length < 1) {
    return []
  }

  return cellList.map((cell) => {
    return {
      ...cell,
      event_list: convertEventBodyJson(cell?.event_list),
    }
  })
}
